/* eslint-disable no-nested-ternary */
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import React, { useState, useEffect } from 'react';
import { useIntl, history, connect, useParams } from 'umi';
import { Segment, Switch, Badge } from 'tea-component';
import { updateDetailsPagePathURL } from '../utils';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';
import '@/pages/intelligence/assets/scss/TopCharts/Companies/GamesDetails/gamesStats.scss';
import RevenueDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/RevenueDownload';
import PhysicalRevenue from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/PhysicalRevenue';
import PCU from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/PCU';
import MAU from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/MAU';
import DigitalRevenue from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DigitalRevenue';
import GamesOwned from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/GamesOwned';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { getGamesStatsPageLogMes } from './_config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { COMBINEID_REG } from '@intelligence/utils/constant';

const GamesStats = (props: any) => {
  const {
    headerFixed,
    companyId,
    activeSegment,
    activeSubSegment,
    basicInfo,
    dataSources,
  } = props;
  const { segment: pathSegment } = useParams<any>();

  const [showSelectType, setShowSelectType] = useState(true);

  const { formatMessage } = useIntl();
  const [mainLoading, setMainLoading] = useState(false);
  const [downloadParamsNormal, setDownloadParamsNormal] = useState({});
  const [initialSegment, initialSubSegment] = pathSegment?.split('_') ?? [];
  const [destroyed, setDestroyed] = useState(false);
  const [segment, setSegment] = useState(
    ['mobile', 'pc', 'console', 'gamesOwned'].includes(initialSegment)
      ? initialSegment
      : 'mobile',
  );

  useEffect(() => {
    if (segment === 'mobile') {
      setShowSelectType(false);
    } else {
      setShowSelectType(true);
    }
  }, [segment]);

  const [subSegment, setSubSegment] = useState(
    initialSubSegment ? initialSubSegment : 'revenue',
  );

  const { gamesStatsOptions } = useCompanyOptionList();
  const getSubOptions = (options: any[], value: string) => {
    const option = options?.find((item) => item?.value === value);
    return option ? option?.subOptions : [];
  };

  // 增加纯国家列表以用来简称匹配全称用
  const [regionsCountries, setRegionsCountries] = useState<any>([]);
  // 获取全局国家地区数据
  const { regionOptions } = useMarketFilterApi({});

  useEffect(() => {
    setRegionsCountries(regionOptions);
  }, [regionOptions]);

  const changeSubSegement = (value: string) => {
    setSubSegment(value);
    handlePageLog(segment, value, companyId);
    updateDetailsPagePathURL({
      companyId,
      tab: 'GamesStats',
      sbuTab: `${segment}_${value}`,
    });
  };

  useEffect(() => {
    if (!companyId) return;
    if (!COMBINEID_REG.test(companyId)) return; // 添加ID校验规则
    handlePageLog(segment, subSegment, companyId);
  }, []);

  const handlePageLog = (tab: string, subTab: string, companyId: string) => {
    const pageLogMes = getGamesStatsPageLogMes(tab, subTab);
    if (companyId && pageLogMes) {
      buriedPointGame(pageLogMes, companyId, 'company_id');
    }
  };

  return (
    <div className="dbi-mobile-games-stats">
      <div className="mobile-games-flex">
        <Segment
          className="segment-light games-left"
          value={segment}
          onChange={(payload) => {
            if (segment === payload) {
              return;
            }
            setSegment(payload);
            const subOptions = getSubOptions(gamesStatsOptions, payload);
            const subValues = subOptions?.[0]?.value;
            setSubSegment(subValues);
            if (COMBINEID_REG.test(companyId)) {
              handlePageLog(payload, subValues, companyId);
            }
            setDestroyed(true);
            setTimeout(() => {
              setDestroyed(false);
            }, 0);
            updateDetailsPagePathURL({
              companyId,
              tab: 'GamesStats',
              sbuTab: subValues ? `${payload}_${subValues}` : payload,
            });
          }}
          options={gamesStatsOptions}
        />
        {segment === 'mobile' ? (
          <>
            <Segment
              className="segment-light games-left"
              value={subSegment}
              onChange={(value) => {
                if (subSegment === value) {
                  return;
                }
                changeSubSegement(value);
                setDestroyed(true);
                setTimeout(() => {
                  setDestroyed(false);
                }, 0);
              }}
              options={getSubOptions(gamesStatsOptions, 'mobile')}
            />
            <TipContext
              tipText={
                subSegment === 'revenue'
                  ? formatMessage({ id: `dbi_info_company_revenue_filter` })
                  : formatMessage({ id: `dbi_info_company_downloads_filter` })
              }
              className="games-left-tip"
            />
          </>
        ) : segment === 'pc' ? (
          <>
            <Segment
              className="segment-light games-left"
              value={subSegment}
              onChange={(value) => changeSubSegement(value)}
              options={getSubOptions(gamesStatsOptions, 'pc')}
            />
          </>
        ) : segment === 'console' ? (
          <>
            <Segment
              className="segment-light games-left"
              value={subSegment}
              onChange={(value) => changeSubSegement(value)}
              options={getSubOptions(gamesStatsOptions, 'console')}
            />
          </>
        ) : null}
      </div>
      {destroyed ? null : segment === 'mobile' &&
        (subSegment === 'revenue' || subSegment === 'downloads') ? (
        <RevenueDownload
          headerFixed={headerFixed}
          entityType={segment}
          companyId={companyId}
          tabId={subSegment === 'downloads' ? 'download' : 'revenue'}
          gameName={basicInfo?.name}
          regionsCountries={regionsCountries}
          setMainLoading={setMainLoading}
          mainLoading={mainLoading}
          setDownloadParamsNormal={setDownloadParamsNormal}
          downloadParamsNormal={downloadParamsNormal}
          dataSources={dataSources}
          showSelectType={showSelectType}
        />
      ) : (segment === 'pc' || segment === 'console') &&
        subSegment === 'digitalRevenue' ? (
        <DigitalRevenue
          companyId={companyId}
          tabId={subSegment}
          entityType={segment}
          regionsCountries={regionsCountries}
          gameName={basicInfo?.name}
          setMainLoading={setMainLoading}
          mainLoading={mainLoading}
          setDownloadParamsNormal={setDownloadParamsNormal}
          downloadParamsNormal={downloadParamsNormal}
        />
      ) : (segment === 'pc' || segment === 'console') &&
        subSegment === 'physicalRevenue' ? (
        <PhysicalRevenue
          companyId={companyId}
          tabId={subSegment}
          entityType={segment}
          regionsCountries={regionsCountries}
          gameName={basicInfo?.name}
          setMainLoading={setMainLoading}
          mainLoading={mainLoading}
          setDownloadParamsNormal={setDownloadParamsNormal}
          downloadParamsNormal={downloadParamsNormal}
        />
      ) : (segment === 'pc' || segment === 'console') &&
        subSegment === 'pcu' ? (
        <PCU
          companyId={companyId}
          tabId={subSegment}
          entityType={segment}
          regionsCountries={regionsCountries}
          gameName={basicInfo?.name}
          setMainLoading={setMainLoading}
          mainLoading={mainLoading}
          setDownloadParamsNormal={setDownloadParamsNormal}
          downloadParamsNormal={downloadParamsNormal}
        />
      ) : (segment === 'pc' || segment === 'console') &&
        subSegment === 'mau' ? (
        <MAU
          companyId={companyId}
          tabId={subSegment}
          entityType={segment}
          regionsCountries={regionsCountries}
          gameName={basicInfo?.name}
          setMainLoading={setMainLoading}
          mainLoading={mainLoading}
          setDownloadParamsNormal={setDownloadParamsNormal}
          downloadParamsNormal={downloadParamsNormal}
        />
      ) : segment === 'gamesOwned' ? (
        <GamesOwned
          companyId={companyId}
          tabId={subSegment}
          setMainLoading={setMainLoading}
          mainLoading={mainLoading}
          downloadParamsNormal={downloadParamsNormal}
          gameName={basicInfo?.name}
        />
      ) : null}
    </div>
  );
};

export default GamesStats;
